// extracted by mini-css-extract-plugin
export default {"container":"Rent_container__6o01J","titulo":"Rent_titulo__AsA2G"};